export default __webpack_public_path__ + "static/media/gray.0f8dcdc8.svg";